var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"link--btn",class:_vm.classList},[_c('router-link',{attrs:{"to":_vm.link}},[_c('div',{staticClass:"link--btn__inner"},[_c('span',{staticClass:"link--btn__in"},[_vm._v(_vm._s(_vm.text))])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }